import { hashKey } from '@simpledotink/notion-utils';
import { useCallback } from 'react';
import { useNotionContext } from '../context';
import { retrieveBlocks } from '../utils';
export function UseRetrieveBlocks() {
    var _a = useNotionContext(), recordMap = _a.recordMap, fetchBlocks = _a.fetchBlocks, fetchHashmap = _a.fetchHashmap, queryCollection = _a.queryCollection, fetchImageBlocks = _a.retrieveImageBlocks;
    var retrieveMissingBlocks = useCallback(function (blockIds) {
        var missingblocks = blockIds.filter(function (m) { return !recordMap.block[m.id]; });
        var key = hashKey({ data: missingblocks });
        if (fetchBlocks && missingblocks.length > 0 && !fetchHashmap[key])
            fetchBlocks(missingblocks);
    }, [recordMap, fetchHashmap, fetchBlocks]);
    var retrieveGroupBlocks = useCallback(function (collectionGroups, collectionData, collection) {
        var retrievedVals = {
            blockIds: [],
            values: []
        };
        collectionGroups.map(function (group) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var collectionSchema = collection.schema;
            var groupSchema = group.schema;
            var value = group.value;
            var optionKey = (_a = Object.entries(collectionSchema).find(function (s) { return s[1].name == groupSchema.name; })) === null || _a === void 0 ? void 0 : _a[0];
            var blockIds = [];
            for (var _i = 0, _m = retrieveBlocks(group.collection, group.collectionView, group.collectionData, recordMap); _i < _m.length; _i++) {
                var blockId = _m[_i];
                var block = (_b = recordMap.block[blockId]) === null || _b === void 0 ? void 0 : _b.value;
                var blockValue = ((_e = (_d = (_c = block === null || block === void 0 ? void 0 : block.properties) === null || _c === void 0 ? void 0 : _c[optionKey]) === null || _d === void 0 ? void 0 : _d.flat()) === null || _e === void 0 ? void 0 : _e.flat()) || [];
                if (blockValue.includes(value) || ((_f = blockValue.flat()) === null || _f === void 0 ? void 0 : _f.includes(value === null || value === void 0 ? void 0 : value.id))) {
                    blockIds.push(blockId);
                }
                else if (typeof value === 'object') {
                    var type = (_h = (_g = value === null || value === void 0 ? void 0 : value.type) === null || _g === void 0 ? void 0 : _g.split('_')) === null || _h === void 0 ? void 0 : _h[1];
                    if (blockValue.includes(value[type]))
                        blockIds.push(blockId);
                    value = value[type] || value;
                }
            }
            group.blockIds = blockIds;
            if (((_k = (_j = collectionData === null || collectionData === void 0 ? void 0 : collectionData[group === null || group === void 0 ? void 0 : group.prop]) === null || _j === void 0 ? void 0 : _j.blockIds) === null || _k === void 0 ? void 0 : _k.length) > 0 &&
                group.blockIds == 0) {
                group.blockIds = (_l = collectionData === null || collectionData === void 0 ? void 0 : collectionData[group === null || group === void 0 ? void 0 : group.prop]) === null || _l === void 0 ? void 0 : _l.blockIds;
            }
            retrievedVals.blockIds.push(group.blockIds);
            retrievedVals.values.push(value);
        });
        return retrievedVals;
    }, [recordMap]);
    var retrieveMissingImageBlocks = useCallback(function (blockIds, cover) {
        var key = hashKey({ data: blockIds, type: cover.type, block: 'image' });
        return new Promise(function (resolve) {
            if (!fetchHashmap[key]) {
                fetchImageBlocks(blockIds, cover === null || cover === void 0 ? void 0 : cover.type).then(function (data) {
                    resolve(data);
                });
            }
            else if (fetchHashmap[key].status == 'success') {
                resolve(fetchHashmap[key].value);
            }
            else {
                return null;
            }
        });
    }, [fetchHashmap, fetchImageBlocks]);
    var retrieveMissingCollections = useCallback(function (collectionId, collectionViewId, loaders) {
        var args = {
            collectionId: collectionId,
            collectionViewId: collectionViewId,
            data: loaders
        };
        var key = hashKey(args);
        if (!fetchHashmap[key]) {
            queryCollection(collectionId, collectionViewId, loaders);
        }
    }, [fetchHashmap, queryCollection]);
    return {
        retrieveMissingBlocks: retrieveMissingBlocks,
        retrieveGroupBlocks: retrieveGroupBlocks,
        retrieveMissingImageBlocks: retrieveMissingImageBlocks,
        retrieveMissingCollections: retrieveMissingCollections
    };
}
//# sourceMappingURL=useRetrieveBlocks.js.map